import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { Select } from "components/common/Select/Select";
import { units } from "store/types/unit";
import { useUnit } from "./useUnit";

type Props = {
  unit: "pixels" | "inch" | "cm" | "mm";
  handleUnitChange: (unit: "pixels" | "inch" | "cm" | "mm") => {
    payload: any;
    type: `bulkResize/${string}`;
  };
};

export const Unit: React.FC<Props> = ({ unit, handleUnitChange }: Props) => {
  return (
    <div className="pt-2">
      <Select
        options={units.map((u) => u)}
        label={capitalize(translateFunc("unit"))}
        value={unit}
        getOptionLabel={(option) => capitalize(translateFunc(option))}
        getOptionValue={(option) => option}
        handleClick={handleUnitChange}
        testKey="unit"
      />
    </div>
  );
};
